import _ from 'lodash';
import { templates } from '../bff.api';
import responseValidators from '../response.validators';

const _handleError = (err, onError) => {
  if (onError) {
    onError(err.message);
  }
};

const _createBody = (data) => {
  const result = { ..._.pick(data, ['name', 'category', 'file']) };

  return result;
};

const _updateBody = (data) => ({ ..._createBody(data) });

const getForCategory = async (category, options = {}) => {
  return templates
    .getForCategory(category)
    .then((resp) => {
      responseValidators.getTemplatesForCategory(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const add = async (data, options = {}) => {
  return templates
    .add(_createBody(data))
    .then((resp) => {
      responseValidators.addTemplate(resp);
      if (options.onSuccess) {
        options.onSuccess(resp.json);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const update = async (id, data, options = {}) => {
  const updateBody = _updateBody(data);
  return templates
    .update(id, updateBody)
    .then((resp) => {
      responseValidators.updateTemplate(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const remove = async (id, options = {}) => {
  return templates
    .remove(id)
    .then((resp) => {
      responseValidators.deleteTemplate(resp);
      if (options.onSuccess) {
        options.onSuccess(resp);
      }
    })
    .catch((err) => _handleError(err, options.onError));
};

const templatesService = {
  getForCategory,
  add,
  update,
  remove
};

export default templatesService;
